import { Controller } from '@hotwired/stimulus'
import * as bootstrap from 'bootstrap'

// Optimistically updates a quick link row's "visited" state when the user
// clicks the Visit button. The button still navigates to the visit endpoint
// in a new tab, which records the click server-side; this controller just
// swaps the icon + refreshes the tooltip in the current tab.
export default class extends Controller {
  static targets = ['icon']

  markVisited() {
    if (!this.hasIconTarget) return

    this.iconTarget.classList.remove('fa-regular', 'fa-circle', 'text-muted')
    this.iconTarget.classList.add('fa-solid', 'fa-circle-check', 'text-primary')

    const newTitle = `Last visited: ${this.#formatNow()}`
    this.iconTarget.setAttribute('title', newTitle)
    this.iconTarget.setAttribute('data-bs-original-title', newTitle)

    const tooltip = bootstrap.Tooltip.getInstance(this.iconTarget)
    if (tooltip) {
      tooltip.setContent({ '.tooltip-inner': newTitle })
    }
  }

  #formatNow() {
    const now = new Date()
    const date = now.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })
    const time = now.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true })
    return `${date} ${time}`
  }
}
